import React, { useEffect, useState } from 'react'

// swiper
// import { Swiper, SwiperSlide } from 'swiper/react'
// import { Navigation, Pagination } from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// custom functions
// import { useViewport } from 'utils'

// resources
// import studioList from 'assets/json/home/studio-list.json'

// styles
import styles from './index.module.scss'
// import StudioSeasonCard from 'components/Card/StudioSeasonCard'
import { DiscoveryFeed } from 'components/Carousel/Discovery-Feed'
import { DiscoveryFeedSkeleton } from 'components/Carousel/Discovery-Feed/SkeletonLoader'
import dashboardAPI from 'apis/dashboard'
import { Product } from 'lib/types'

// call apis

const StudioHeroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [products, setProducts] = useState<Product[]>([])
  useEffect(() => {
    dashboardAPI.getHeroFeed().then(response => {
      if (response !== null && response !== undefined && response.cards !== 0) {
        let cards: Product[] = []
        response.cards.map(card => {
          cards.push({
            id: card.id,
            name: card.items[0].itemName,
            price: card.items[0].price / 100,
            image: card.items[0].itemUrl,
            type: card.items[0].itemType,
            link: card.targetUrl,
            avatar: card.creatorImage,
            category: '',
          })
        })
        setProducts(cards)
        setIsLoaded(true)
      }
    }),
      error => {
        console.log(error)
      }
  }, [])

  return (
    <section className={styles.container}>
      <div className={`${styles.editionSwiper}`}>
        {/* <Swiper
          navigation={viewport === 'xs' || viewport === 'md' ? false : true}
          slidesPerView={1}
          spaceBetween={0}
          centeredSlides={true}
          loop={studioList.length > 1}
          modules={[Navigation, Pagination]}
          pagination={{
            clickable: true,
          }}
          className={
            viewport === 'xs' || viewport === 'md' || viewport === 'sm'
              ? 'heroMobileNavigationSwiper'
              : studioList.length > 1
              ? 'heroNavigationSwiper'
              : 'noScrollNavigationSwiper'
          }
        >
          {studioList.map((item, index) => (
            <SwiperSlide key={index}>
              <StudioSeasonCard data={item} />
            </SwiperSlide>
          ))}
        </Swiper> */}
        {products.length > 0 ? <DiscoveryFeed products={products} /> : <DiscoveryFeedSkeleton />}
      </div>
    </section>
  )
}

export default StudioHeroSection
